import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=68c6648d&scoped=true&lang=pug&"
import script from "./PreviewVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=68c6648d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6648d",
  null
  
)

export default component.exports